<template>
  <div class="meeting-agenda__items-container">
    <AgendaItem v-for="(item, index) in agendaItems" :item="item" :key="`notes-${index}`" :index="index"></AgendaItem>
  </div>
</template>

<script>
  import AgendaItem from './AgendaItem.vue';

  export default {
    name: 'AgendaContainer',
    components: {
      AgendaItem,
    },
    props: ['agenda'],
    computed: {
      agendaItems() {
        return this.agenda ? this.agenda.agenda_items : [];
      },
    },
  };
</script>
